function getEvents(pageId) {
  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "preset",
        eventTypeId: "SCROLLING_IN_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|b6fa2246-64c0-bf9e-5e27-394625647ea8`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|b6fa2246-64c0-bf9e-5e27-394625647ea8`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: [
          {
            continuousParameterGroupId: "a-p",
            smoothing: 50,
            startsEntering: true,
            addStartOffset: false,
            addOffsetValue: 50,
            startsExiting: false,
            addEndOffset: false,
            endOffsetValue: 50,
          },
        ],
        createdOn: 1651477666206,
      },
    },
    actionLists: {
      a: {
        id: "a",
        title: "Layout 352 Timeline Animation",
        continuousParameterGroups: [
          {
            id: "a-p",
            type: "SCROLL_PROGRESS",
            parameterLabel: "Scroll",
            continuousActionGroups: [
              {
                keyframe: 27,
                actionItems: [
                  {
                    id: "a-n",
                    actionTypeId: "STYLE_BACKGROUND_COLOR",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout352_circle",
                        selectorGuids: ["0125bc08-2f87-24a7-103c-ef0badf50267"],
                      },
                      globalSwatchId: "",
                      rValue: "h",
                      bValue: 198,
                      gValue: 198,
                      aValue: 1,
                    },
                  },
                  {
                    id: "a-n-2",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout352_right",
                        selectorGuids: ["0125bc08-2f87-24a7-103c-ef0badf50262"],
                      },
                      value: 0.25,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-3",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout352_left",
                        selectorGuids: ["0125bc08-2f87-24a7-103c-ef0badf50265"],
                      },
                      value: 0.25,
                      unit: "",
                    },
                  },
                ],
              },
              {
                keyframe: 32,
                actionItems: [
                  {
                    id: "a-n-4",
                    actionTypeId: "STYLE_BACKGROUND_COLOR",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout352_circle",
                        selectorGuids: ["0125bc08-2f87-24a7-103c-ef0badf50267"],
                      },
                      globalSwatchId: "dccb7db6",
                      rValue: "h", // to make css circle styling invalid so that the themeUI style is used
                      bValue: 0,
                      gValue: 0,
                      aValue: 1,
                    },
                  },
                  {
                    id: "a-n-5",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout352_right",
                        selectorGuids: ["0125bc08-2f87-24a7-103c-ef0badf50262"],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                  {
                    id: "a-n-6",
                    actionTypeId: "STYLE_OPACITY",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout352_left",
                        selectorGuids: ["0125bc08-2f87-24a7-103c-ef0badf50265"],
                      },
                      value: 1,
                      unit: "",
                    },
                  },
                ],
              },
            ],
          },
        ],
        createdOn: 1650328813245,
      },
    },
    site: {
      mediaQueries: [
        { key: "main", min: 992, max: 10000 },
        {
          key: "medium",
          min: 768,
          max: 991,
        },
        { key: "small", min: 480, max: 767 },
        { key: "tiny", min: 0, max: 479 },
      ],
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
